export const DPSATISFACTION_FORM_URL = 'https://cl.s13.exct.net/DEManager.aspx';
export const DPSATISFACTION_FORM_CLIENT_ID = '546000610';
export const DPSATISFACTION_FORM_DE_EXTERNAL_KEY = 'EBDD6DAA-BAB3-4971-A967-C2997BDE1E93';
export const DPSATISFACTION_FORM_SUCCESS_URL = 'https://www.dportenis.mx/success';
export const DPSATISFACTION_FORM_ERROR_URL = 'https://www.dportenis.mx/failed';
export const DPSATISFACTION_FORM_ACTION = 'add/update';
export const DPSATISFACTION_FORM_RETURN_XML = '0';
